export default __webpack_public_path__ + "static/media/Distributor-14-line.fce6afd8.jpg";